@if (data$ | async; as component) {
  <div class="reverse-banner">
    <div class="h2-component">{{component.title}}</div>
    @if (items$ | async; as components) {
      <div class="reverse-items">
        @for (component of components; track component; let i = $index) {
          @if (component) {
            <app-custom-cms-item [item]="component"></app-custom-cms-item>
          }
        }
      </div>
    }
  </div>
}
